import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { updateUser, updateWidget } from "./slices";
import store from "./store";
import App from "./App";
import CarouselWidget from "./widgets/CarouselWidget";
import SmartSearchWidget from "./widgets/SmartSearchWidget";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "./i18n";

import forEach from "lodash/forEach";

const commonAttributes = [
  {
    name: "userid",
    onAttrChange: (value) => {
      const user = { userId: value };
      store.dispatch(updateUser(user));
    },
  },
];

const commonEvents = [
  {
    name: "onGameClick",
  },
];

const widgets = [
  {
    widgetName: "vaix-carousel-widget",
    component: CarouselWidget,
    events: commonEvents,
    attributes: [
      {
        name: "filters",
        onAttrChange: (value, widgetId) => {
          store.dispatch(
            updateWidget({
              widgetId,
              properties: { filters: value },
            }),
          );
        },
      },
      {
        name: "location",
        onAttrChange: (value, widgetId) => {
          store.dispatch(
            updateWidget({
              widgetId,
              properties: { location: value },
            }),
          );
        },
      },
    ],
  },
  {
    widgetName: "vaix-smart-search-widget",
    component: SmartSearchWidget,
    events: commonEvents,
  },
];

const defineCustomElement = function ({
  widgetName,
  Component,
  events,
  attributes = [],
}) {
  const attrs = [...commonAttributes, ...attributes];

  const WebComponent = class extends HTMLElement {
    static get observedAttributes() {
      return attrs?.map((attr) => attr.name);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      const currentAttr = attrs?.find((a) => a.name === name);
      const { onAttrChange } = currentAttr;
      const widgetId = this.getAttribute("id");
      onAttrChange && onAttrChange(newValue, widgetId);
    }

    connectedCallback() {
      const widgetId = this.getAttribute("id");

      if (!widgetId) {
        throw new Error(`${widgetName} requires a unique id attribute.`);
      }

      const customEvents = events?.reduce((acc, e) => {
        const eventHandler = (data) => {
          this.dispatchEvent(
            new CustomEvent(e.name, {
              detail: data,
            }),
          );
        };
        acc[e.name] = eventHandler;
        return acc;
      }, {});

      ReactDOM.render(
        <Component widgetId={widgetId} {...customEvents} />,
        this,
      );
    }
  };

  customElements.define(widgetName, WebComponent);
};

const createWidgets = (widgets) => {
  forEach(widgets, (widget) => {
    const isNotDefined = !customElements.get(widget.widgetName);
    const { component, ...widgetProps } = widget || {};
    isNotDefined &&
      defineCustomElement({
        ...widgetProps,
        Component: component,
      });
  });
};

(function main() {
  const rootElement = document.getElementById("vaix-demo-root");
  const vaixCustomerSettings = window.vaixCustomerSettings;

  if (vaixCustomerSettings || rootElement) {
    createWidgets(widgets);
  }

  if (rootElement) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>,
      rootElement,
    );
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
